import { getStarknet } from './amm_v3'
import { PublicNetwork, StarknetChainId } from './token.service'

export const networkId = async (): Promise<PublicNetwork | undefined> => {
    try {
        const chainId = await window.getStarknet?.()?.provider?.getChainId()
        return networkNameByChainId(chainId)
    } catch {}
}

export const networkNameByChainId = (chainId: string | undefined): PublicNetwork => {
    switch (chainId) {
        case StarknetChainId.MAINNET:
            return 'mainnet-alpha'
        case StarknetChainId.TESTNET:
            return 'goerli-alpha'
        case StarknetChainId.SEPOLIA_TESTNET:
            return 'sepolia-alpha'
        default:
            return 'mainnet-alpha'
        // return undefined
    }
}

export const addToken = async (address: string): Promise<void> => {
    const starknet = await getStarknet()

    // patch for Argent bug - expecting a 66 char string
    address = '0x' + '0'.repeat(66 - address.length) + address.substring(2)

    await starknet?.request({
        type: 'wallet_watchAsset',
        params: {
            type: 'ERC20',
            options: {
                address
            }
        }
    })
}

export const getExplorerUrlBase = (network: string): string | undefined => {
    switch (network) {
        case 'mainnet-alpha':
            return 'https://voyager.online'
        case 'goerli-alpha':
            return 'https://goerli.voyager.online'
    }
}

// export const networkUrl = (): string | undefined => {
//     try {
//         return getStarknet().provider.baseUrl
//     } catch {}
// }

// export const signMessage = async (message: string) => {
//     const starknet = getStarknet()
//     await starknet.enable()

//     // checks that enable succeeded
//     if (starknet.isConnected === false) throw Error('starknet wallet not connected')
//     if (!shortString.isShortString(message)) {
//         throw Error('message must be a short string')
//     }

//     return starknet.signer.signMessage({
//         domain: {
//             name: 'Example DApp',
//             chainId: networkId() === 'mainnet-alpha' ? 'SN_MAIN' : 'SN_GOERLI',
//             version: '0.0.1'
//         },
//         types: {
//             StarkNetDomain: [
//                 { name: 'name', type: 'felt' },
//                 { name: 'chainId', type: 'felt' },
//                 { name: 'version', type: 'felt' }
//             ],
//             Message: [{ name: 'message', type: 'felt' }]
//         },
//         primaryType: 'Message',
//         message: {
//             message
//         }
//     })
// }

// export const waitForTransaction = async (hash: string) =>
//     await getStarknet().provider.waitForTx(hash)
